import React from "react";

const SeasonalAppLogo = ({ ShellHeaderLogo, minify }) => {
    const month = new Date().getMonth(); // 0 = january, 9 = october, 11 = december

    let logoSrc = minify ? `/aGlobalDesign/Branding/${ShellHeaderLogo.name}_minify${ShellHeaderLogo.ext}` : `/aGlobalDesign/Branding/${ShellHeaderLogo.name}${ShellHeaderLogo.ext}`;

    if (month === 9) {
    // October -> Halloween
        logoSrc = `/aGlobalDesign/Branding/${ShellHeaderLogo.name}_halloween${ShellHeaderLogo.ext}`;
    }
    else if (month === 11) {
    // December -> Christmas
        logoSrc = `/aGlobalDesign/Branding/${ShellHeaderLogo.name}_halloween${ShellHeaderLogo.ext}`;
    }

    return (
        <img
            src={logoSrc}
            alt="Logo"
            className="app-logo"
            onClick={() => {
                window.location.href = "/";
            }}
            style={{ width: minify ? "25px" : "116px"}}
        />
    );
};

export default SeasonalAppLogo;
